import {
  action, flow, makeObservable, observable,
} from 'mobx';

import { CaseAdapter } from '@shared/CaseAdapter';
import BaseStore from './BaseStore';
import DemarcheCasesAPI from '../api/demarche_cases_api';
import { DemarcheCase } from '../components/DemarchesPermis/types';

// Backs F5 (the client's own case-tracking list/detail), a persistent view the student revisits —
// unlike DemarcheFunnelStore, this never resets on navigation.
class DemarcheCasesStore extends BaseStore {
  cases: DemarcheCase[] = [];
  selectedCase: DemarcheCase | null = null;
  isCasesLoading = false;
  isCaseLoading = false;
  casesErrorStatus: number | null = null;
  caseErrorStatus: number | null = null;

  constructor() {
    super();

    makeObservable(this, {
      cases: observable,
      selectedCase: observable,
      isCasesLoading: observable,
      isCaseLoading: observable,
      casesErrorStatus: observable,
      caseErrorStatus: observable,
      reset: action,
    });
  }

  fetchCases = flow(function* fetchCases(this: DemarcheCasesStore) {
    this.isCasesLoading = true;
    this.casesErrorStatus = null;

    try {
      const { data } = yield DemarcheCasesAPI.list();
      const { cases } = CaseAdapter.toFrontFormat(data) as { cases: DemarcheCase[] };
      this.cases = cases;
    } catch (e) {
      this.casesErrorStatus = e.response?.status || 500;
      console.error(e);
    } finally {
      this.isCasesLoading = false;
    }
  });

  fetchCase = flow(function* fetchCase(this: DemarcheCasesStore, id: string) {
    this.isCaseLoading = true;
    this.caseErrorStatus = null;

    try {
      const { data } = yield DemarcheCasesAPI.show(id);
      this.selectedCase = CaseAdapter.toFrontFormat(data) as DemarcheCase;
    } catch (e) {
      this.caseErrorStatus = e.response?.status || 500;
      console.error(e);
    } finally {
      this.isCaseLoading = false;
    }
  });

  reset = (): void => {
    this.cases = [];
    this.selectedCase = null;
    this.isCasesLoading = false;
    this.isCaseLoading = false;
    this.casesErrorStatus = null;
    this.caseErrorStatus = null;
  };
}

export { DemarcheCasesStore };

export default new DemarcheCasesStore();
